import { render, staticRenderFns } from "./ApproveIpRangesPanel.vue?vue&type=template&id=2225cdf1&scoped=true&"
import script from "./ApproveIpRangesPanel.vue?vue&type=script&lang=js&"
export * from "./ApproveIpRangesPanel.vue?vue&type=script&lang=js&"
import style1 from "./ApproveIpRangesPanel.vue?vue&type=style&index=1&id=2225cdf1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2225cdf1",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/users/ApproveIpRangesPanel.vue
// module id = 1469
// module chunks = 0